import { render, staticRenderFns } from "./SpecialistProfile.vue?vue&type=template&id=5354ed70&scoped=true"
import script from "./SpecialistProfile.vue?vue&type=script&lang=js"
export * from "./SpecialistProfile.vue?vue&type=script&lang=js"
import style0 from "./SpecialistProfile.vue?vue&type=style&index=0&id=5354ed70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354ed70",
  null
  
)

export default component.exports